import { render } from "./CourseSchedule.vue?vue&type=template&id=216dd2ac&scoped=true"
import script from "./CourseSchedule.vue?vue&type=script&lang=js"
export * from "./CourseSchedule.vue?vue&type=script&lang=js"

import "./CourseSchedule.vue?vue&type=style&index=0&id=216dd2ac&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216dd2ac"]])

export default __exports__